import React from 'react';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from 'react-jss';
import { BrowserRouter } from 'react-router-dom';
import { appTheme } from '@ccr-unione/unione.assmnt.ui-kit.webapp/lib/theme';
import { Wrapper } from '@ccr-unione/unione.commons.webpack';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.scss';

const rootElement = document.getElementById('root');

if (rootElement !== null) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Wrapper>
        <BrowserRouter>
          <ThemeProvider theme={appTheme}>
            <App />
            <Toaster position="top-right" />
          </ThemeProvider>
        </BrowserRouter>
      </Wrapper>
    </React.StrictMode>,
  );
}
